import './bootstrap'
import '../css/app.css'
import 'floating-vue/dist/style.css';

// Import modules...
import { createApp, h } from 'vue';
import { Head, Link, createInertiaApp } from '@inertiajs/vue3'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { globalFilters } from "./Shared/globalProperties";
import shadow from "vue-shadow-dom";
import FormInput from './Shared/Components/FormInput.vue'
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/index.esm';
import Notifications from '@kyvg/vue3-notification';
import FloatingVue from 'floating-vue'

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Giesen Configurator';
const asset = (path) => {
    if (!path) {
        return ''
    }

    if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('/')) {
        return path
    }

    return `/${path}`
}

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })
            .component('InertiaHead', Head)
            .component('InertiaLink', Link)
            .component('FormInput', FormInput)
            .use(plugin)
            .use(ZiggyVue, Ziggy)
            .use(FloatingVue)
            .use(Notifications)
            .use(shadow)
            .mixin({ methods: { route, asset } });

        app.config.globalProperties.$filter = globalFilters;

        app.mount(el)
    },
    // progress: {
    //     color: "#4B5563",
    // },
})

if (import.meta.env.NODE_ENV === "production") {
    InertiaApp.on("navigate", (event) => {
        gtag('event', 'page_view', {
            'page_location': event.detail.page.url
        });
        gtag("js", new Date());
        gtag("config", "G-WSFNHH26K2");
    });
}
